<!--
* 组件名 : 人物信息弹框
* 开发者 : JY
*
* 参数:
*  data    { Object }  []  -  人物信息
*
* 事件:
*  itemClick  [] - 传递关闭弹框方法
*
-->

<template>
  <section class="v-person-info-modal">
    <div
      class="tooltip-modal-box"
      v-bg-img="'images/common/persecution-modal-bg.png'"
    >
      <div class="tooltip-body d-flex">
        <div class="img-box">
          <img :src="data['poster']" />
        </div>
        <div class="info-content">
          <h4>{{ $P.uni2zg(data["name"]) }}</h4>
          <div class="info-nano nano" ref="infoNano">
            <div class="nano-content">
              <p class="desc" ref="descWrap">
                {{ $P.uni2zg(data["desc"]) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <v-btn class="close-btn" @btnClick="$emit('onClose')">
        <v-icon>clear</v-icon>
      </v-btn>
    </div>
  </section>
</template>

<script>
import { timeout } from "@/utils/util";
export default {
  name: "person-info-modal",
  props: {
    data: {
      type: Object,
      required: true,
      default: {},
    },
  },
  watch: {
    data: function(val, oldVal) {
      this.nano_scroller_fn();
    },
  },
  mounted() {
    this.nano_scroller_fn();
  },
  methods: {
    /**
     * 判断是否启用 nanoScroller
     */
    nano_scroller_fn() {
      let nanoHeight = this.$refs.infoNano.clientHeight;
      let descHeight = this.$refs.descWrap.scrollHeight;
      timeout(100).then(() => {
        (descHeight > nanoHeight) & $(".info-nano").nanoScroller();
      });
    },
  },
};
</script>

<style lang="scss">
.v-person-info-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.5);

  &.open {
    .tooltip-body {
      background-color: transparent;
    }
  }

  @include flex(center, center);

  .tooltip-modal-box {
    width: 760px;
    height: calc(760px * 0.84);
    position: relative;
    padding: 10px;
    background: {
      repeat: no-repeat;
      size: contain;
    }
  }

  .tooltip-body {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 3;
    padding: 75px 36px 60px 58px;
    // background-color: #f5f3e4;

    .img-box {
      width: 170px;
      height: calc(170px * 1.4);
      background-color: $color-placeholder;

      img {
        width: 100%;
      }
    }

    .info-content {
      margin-left: 38px;
      width: calc(100% - 208px);

      .nano {
        height: calc(100% - 50px);
      }

      .nano-content {
        padding-right: 16px;
      }
    }

    h4 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .desc {
      font-size: 18px;
      line-height: 1.6;
    }
  }

  .close-btn {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.66);
    right: -15px;
    top: -15px;
    z-index: 44;
    border-radius: 50%;
    opacity: 0.8;
    transition: opacity 0.5s ease;

    &:hover {
      opacity: 1;
    }

    i {
      color: $color-white !important;
    }
  }

  @media (max-height: 770px) {
    .tooltip-modal-box {
      width: 600px;
      height: calc(600px * 0.84);
    }

    .tooltip-body {
      padding: 46px 24px 60px 28px;

      .img-box {
        width: 150px;
        height: calc(150px * 1.4);
      }

      .info-content {
        margin-left: 30px;
        width: calc(100% - 180px);
      }

      h4,
      .desc {
        font-size: 16px;
      }
    }
  }
}
</style>
